module.exports = __webpack_public_path__ + "img/pines.e449b2e1.svg";